<template>
  <h2 class="content-block">Operator Details</h2>
  <div v-if="loading" class="loading-overlay">
    LOADING...
    <span class="loader"></span>
  </div>
  <div v-else>
  <DxToolbar class="menubar">
    <DxItem
        :options="cancelButtonOptions"
        location="before"
        widget="dxButton"
      />
    <DxItem
        :options="saveButtonOptions"
        location="before"
        widget="dxButton"
      />
    <DxItem
        :options="deleteButtonOptions"
        location="before"
        widget="dxButton"
      />
  </DxToolbar>

  <div class="content-block dx-card responsive-paddings">
    <DxForm id="form" 
        :form-data="operators" 
        :label-mode="outside" 
        :read-only="false" 
        :show-colon-after-label="true"
        :label-location="top" 
        :col-count="1" 
        :min-col-width="300" 
        :width="null"
        :items="['operatorId', 'operatorName', 'operatorEternal']">
      >
      <DxSimpleItem data-field="operatorId"  :editor-options="{readOnly: true}" />
      <DxSimpleItem data-field="operatorName" />
      <DxSimpleItem data-field="operatorExternal" />
    </DxForm>
  </div>
  </div>
</template>

<script>

import DxForm, { DxSimpleItem } from "devextreme-vue/form";
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';
import notify from 'devextreme/ui/notify';

export default {
  components: {
    DxForm, 
    DxSimpleItem, 
    DxToolbar,
    DxItem
  },
  created() {
    this.loadPageData();
  },
  data() {
    return {
      loading: true,
      cancelButtonOptions: {
        icon: 'revert',
        onClick: () => {
          //this.refreshData();
          this.$router.go(-1);
        },
      },
      saveButtonOptions: {
        icon: 'save',
        onClick: () => {
          if (this.operators.operatorId==0)
          {
            this.$store.dispatch('operators/addOperator', this.operators);
            this.$emit('recordUpdated');
          }
          else
          {
            this.$store.dispatch('operators/updateOperator', this.operators);
            this.$emit('recordUpdated');
          }
        },
      },
      deleteButtonOptions: {
        icon: 'close',
        onClick: () => {
          let result = confirm("<b>Are you sure you want to delete this operator?</b>" + 
            "<p>Name: " + this.operators.operatorName,
            "Delete?");
          result.then((dialogResult) => {this.delete(dialogResult);});
        },
      },
    };
  },
  computed: {
    currentRecordId() {
      return this.$route.path.substring(this.$route.path.lastIndexOf('/') + 1); 
    },
    operators() {
      return this.$store.getters["operators/getCurrentOperator"];
    },
  },
  methods: {
    async delete(confirmed){
      if (!confirmed)
      { 
        this.popNotification('Delete record cancelled.','warning');
        return; 
      }
      this.popNotification("Record deleted. ", 'success');

      await this.$store.dispatch('operators/deleteOperator', {operatorId: this.operators.operatorId});
      this.$emit('recordUpdated');
    },
    refreshData(){
      this.loadPageData();
    },
    async loadPageData(refresh = false) {
      this.loading = true;
      try {
        await this.$store.dispatch("operators/loadOperator", { id: this.currentRecordId });
      } catch (error) {
        this.error = error.message || "Unexpected Error.";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.menubar{
  padding: 0 60px 0 60px ;
}
</style>
